import { render, staticRenderFns } from "./delivery.vue?vue&type=template&id=34368bfe&scoped=true"
import script from "./delivery.vue?vue&type=script&lang=js"
export * from "./delivery.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34368bfe",
  null
  
)

export default component.exports